import BaseClass from "../../../util/BaseClass";
import FieldNames from "../../../aiim/datasets/FieldNames";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as officePlanUtil from "../../base/officePlanUtil";
import * as queryUtil from "../../base/queryUtil";

/*
"codedValues": [
     {
      "name": "Square miles",
      "code": 1
     },
     {
      "name": "Square kilometers",
      "code": 2
     },
     {
      "name": "Acres",
      "code": 3
     },
     {
      "name": "Hectares",
      "code": 4
     },
     {
      "name": "Square yards",
      "code": 5
     },
     {
      "name": "Square feet",
      "code": 6
     },
     {
      "name": "Square inches",
      "code": 7
     },
     {
      "name": "Square meters",
      "code": 8
     },
     {
      "name": "Square centimeters",
      "code": 9
     },
     {
      "name": "Square millimeters",
      "code": 10
     }
    ],
 */

export default class AreaStatsModel extends BaseClass {

  queryStats(areaItem,areaType) {
    const promise = new Promise((resolve,reject) => {

      const unitsSource = officePlanUtil.getUnitsSource();
      const unitFields = unitsSource.layer2D.fields;
      const unitsWhere = officePlanUtil.makeWhereForUnitsAssignedToArea(areaItem,areaType);
      const areaField = aiimUtil.findField(unitFields,FieldNames.UNITS_AREA_GROSS);
      const capacityField = aiimUtil.findField(unitFields,FieldNames.UNITS_CAPACITY);
      const sumAreaStat = {
        onStatisticField: areaField.name,
        outStatisticFieldName: "sumArea",
        statisticType: "sum"
      };
      const sumCapacityStat = {
        onStatisticField: capacityField.name,
        outStatisticFieldName: "sumCapacity",
        statisticType: "sum"
      };
      const unitOutStatistics = [sumAreaStat,sumCapacityStat];
      const unitCountOptions = {
        source: unitsSource,
        where: unitsWhere
      };
      const unitStatOptions = {
        source: unitsSource,
        outStatistics: unitOutStatistics,
        where: unitsWhere
      };

      const peopleSource = officePlanUtil.getPeopleSource();
      const peopleWhere = officePlanUtil.makeWhereForPeopleAssignedToArea(areaItem,areaType);
      const peopleCountOptions = {
        source: peopleSource,
        where: peopleWhere
      };

      const p1 = queryUtil.queryCount(peopleCountOptions);
      const p2 = queryUtil.queryCount(unitCountOptions);
      const p3 = queryUtil.queryStats(unitStatOptions);

      Promise.all([p1,p2,p3]).then(results => {
        const peopleCount = results[0];
        const unitCount = results[1];
        const unitStats = results[2];
        let sumArea = 0, sumCapacity = 0;
        if (unitStats && unitStats.features && unitStats.features.length === 1) {
           const attributes = unitStats.features[0].attributes;
           sumArea = aiimUtil.getAttributeValue(attributes,"sumArea");
           sumCapacity = aiimUtil.getAttributeValue(attributes,"sumCapacity");
        }
        const info = {
          peopleCount: peopleCount,
          unitCount: unitCount,
          sumArea: sumArea,
          sumCapacity: sumCapacity
        };
        resolve(info);
      }).catch(ex => {
        reject(ex);
      });

      // queryUtil.queryStats(unitOptions).then(unitResults => {
      //   //console.log("unitStatResults",unitResults)
      //   if (unitResults && unitResults.features && unitResults.features.length === 1) {
      //     let attributes = unitResults.features[0].attributes;
      //   }
      //   resolve();
      // }).catch(ex => {
      //   reject(ex);
      // });

/*
[
  {
    "statisticType": "<count | sum | min | max | avg | stddev | var>",
    "onStatisticField": "Field1",
    "outStatisticFieldName": "Out_Field_Name1"
  },
  {
    "statisticType": "<count | sum | min | max | avg | stddev | var>",
    "onStatisticField": "Field2",
    "outStatisticFieldName": "Out_Field_Name2"
  }
]
 */




/*
var query = layer.createQuery();
query.where = "STATE_NAME = 'Washington'";
query.outStatistics = [ sumPopulation, avgPopulation, populationChangeDefinition ];
layer.queryFeatures(query)
  .then(function(response){
     var stats = response.features[0].attributes;
     console.log("Total Population in WA": stats.Pop_2015_sum);
     console.log("Average Population in WA counties": stats.Pop_2015_avg);
     console.log("Average Population change in WA counties": stats.avg_pop_change_2015_2010);
  });
 */
    });
    return promise
  }

}
